import { render, staticRenderFns } from "./quarter-table.vue?vue&type=template&id=2cc64086"
import script from "./quarter-table.vue?vue&type=script&lang=js"
export * from "./quarter-table.vue?vue&type=script&lang=js"
import style0 from "./quarter-table.vue?vue&type=style&index=0&id=2cc64086&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports